/**
 * Name: MenuItem
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class MenuItem extends Collapsible {
  static settings = {
    control: '.js-menu-control',
    target: '.js-menu-target',
  };

  constructor (element, options = {}) {
    super(element, {
      ...MenuItem.settings,
      ...options,
    });
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  open () {
    const el = this.target;

    el.removeAttribute('hidden');

    const height = el.scrollHeight;

    el.style.height = '0px';
    el.offsetHeight;
    el.style.height = height + 'px';

    super.open();

    el.addEventListener('transitionend', () => {
      el.style.height = 'auto';
    }, { once: true });
  }

  close (refocus = true) {
    const el = this.target;

    const height = el.scrollHeight;

    el.style.height = height + 'px';
    el.offsetHeight;
    el.style.height = '0px';

    el.addEventListener('transitionend', () => {
      el.setAttribute('hidden', '');
      super.close(refocus);
    }, { once: true });
  }

  mount () {
    super.mount();
    this.target.classList.add('has-menu-item');
    this.target.setAttribute('tabindex', '-1');
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('has-menu-item');
    this.target.removeAttribute('tabindex');
  }
}
